<template>
  <div>
    <p v-if="tags.length > 0" class="text-body-1 font-weight-bold" style="margin-top: 16px">Tags</p>
    <v-chip
      class="chip"
      v-for="(tag, ind) in tags"
      :key="ind"
      :close="editable"
      @click:close="handleTagClose(tag)"
    >{{tag}}
    </v-chip>
    <div v-if="editable">
      <v-text-field
        v-if="editable"
        v-model="newTag"
        label="Add Tag"
        hint="Add a new tag to this article"
        @input="$v.newTag.$touch()"
        @blur="$v.newTag.$touch()"
        @keyup.enter="handleTagAdd"
      >
      </v-text-field>
      <v-btn class="primary"
        :disabled="$v.$invalid"
        @click="handleTagAdd"
      >
        Add
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { validationMixin } from '../validators.js'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      newTag: ''
    }
  },
  computed: {
    ...mapState('article', {
      tags (state) {
        return this.editable ? state.articleEdits.tags : state.currentArticle.tags
      }
    })
  },
  methods: {
    ...mapMutations('article', [
      'removeTag',
      'addTag'
    ]),
    handleTagClose (tag) {
      this.removeTag(tag)
    },
    handleTagAdd () {
      if (!this.tags.includes(this.newTag) && !this.$v.$invalid) this.addTag(this.newTag)
    }
  },
  validations: {
    newTag: {
      maxLength: maxLength(40),
      minLength: minLength(1),
      required
    }
  }
}
</script>

<style>
.chip {
  margin: 2px 2px 2px 2px;
}
</style>
